<common-header-modal>
</common-header-modal>
<div class="modal-body">
  <h3>{{'LOGISTICS.LINES_DETAIL' | translate}}</h3>
  <common-user-view class="linesDetailModal"
                    [gridContext]="this"
                    [service]="service"
                    [showPageSizeSelect]="false"
                    [hideEditButtons]="true"
                    [preventAutoSize]="true"
                    [sortable]="false">
  </common-user-view>
</div>
<div class="modal-footer btnSendStatus"
     style="margin-top:0;">
  <div class="float-end">
    <button type="button"
            class="btn btn-default"
            (click)="modalRef.hide()">{{'SHARED.TXT_MODAL_CLOSE' | translate}}</button>
  </div>
</div>